const createEmptyItem = (columns) => {
    return columns
        .map((col) => col.propertyName)
        .filter((prop) => !!prop)
        .reduce((acc, prop) => {
        acc[prop] = '';
        return acc;
    }, {});
};
const removeValueAtId = (values, deleteId) => {
    const copiedValue = structuredClone(values);
    copiedValue.splice(deleteId, 1);
    return copiedValue;
};
const changeValueById = (values, newValue, changedId) => {
    const copiedValue = structuredClone(values);
    copiedValue[changedId] = newValue;
    return copiedValue;
};
export const tableDataUtils = { createEmptyItem, removeValueAtId, changeValueById };
//# sourceMappingURL=tableData.utils.js.map